<template>
    <div v-show="pageData.length > 0">
        <div>
            <span class="common-title">追溯记录</span>
        </div>
        <div class="chart-box"><div id="tableChart" :style="'height:' + chartHeight +'px'"></div></div>
        <goldDetailDialog ref="goldDetailDialog" :id.sync="goldDetailDialogId" :isFnc.sync="isFnc"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import { queryPayRecord } from "@/api/gold.js"
import goldDetailDialog from "./gold-detail-dialog"
export default {
    name:"gold-detail-flow-detail",
    props:{
        goldData:{
            type:Object
        }
    },
    data() {
        return {
            pageData:[],
            showMore:false,
            treeData:[],
            myChart:null,
            goldDetailDialogId:undefined,
            chartHeight:500,
            isFnc:false
        }
    },
    components:{
        goldDetailDialog
    },
    computed: {
        ...mapGetters({
            parentData:"app/getGoldDetailPrarms"
        }),
        way(){
            if(this.parentData){
                return this.parentData.way;
            }
            return this.$route.params.way;
        },
        gldId(){
            if(this.parentData){
                return this.parentData.gldId;
            }
            return this.$route.params.gldId;
        },
        gldStCds(){
            const fromType = this.parentData?this.parentData.fromType:this.$route.params.fromType;
            switch(fromType){
                case "3":
                    return "0,1,5,6,7";
                case "5":
                    return "";
                default:
                    return  "";
            }
        },

    },
    created() {
        this.queryPayRecord();
    },
    mounted() {
        let self = this;
        window.clickChartTreeNode = function(id, isFin){
            self.$nextTick(() => {
                setTimeout(() => {
                    self.myChart.dispatchAction({
                        type: 'hideTip',         //提示框
                    });
                },2000)

                self.goldDetailDialogId = id;
                self.isFnc = (isFin == "融资"); //判断是否为融资的祺信
                console.log(self.isFnc)
                self.$refs.goldDetailDialog.open();
            })
        }
    },
    methods: {
        queryPayRecord(){
            let param = {
                gldStCds:this.gldStCds,
                gldIdAllchain:this.gldId
            }
            queryPayRecord(param)
            .then((res) => {
                this.pageData = res.data.list;
                let levelList = this.pageData.map(i => i.gldLevel);
                let max = Math.max(...levelList);
                this.chartHeight = this.pageData.length ? 188 * max : this.chartHeight;
                this.renderTree(this.pageData);
            }).catch(err => {
                console.log(err);
            });
        },
        renderTree(menuSrc){
            // 根据返回数据生成树形结构
            let menuTemp = {}; //定义一个临时数据 可以根据id 获取到节点
            let renderData = [
                {
                    name:'',
                    children:[],
                    isParent:true
                }
            ];
            menuSrc.forEach(menuItem => {
                menuTemp[menuItem.gldId] = menuItem;
                menuItem.children = []; //初始化子节点列表
            });
            menuSrc.forEach(menuItem => {
                if(menuItem.gldLevel == 1){ //一级菜单
                    renderData[0].name = menuItem.pypt;
                    menuItem.name = menuItem.rcPty;
                    renderData[0].children.push(menuItem);
                    menuItem.gldStCd = this.goldData.gldStCd
                }else{ //子节点
                    menuItem.name = menuItem.rcPty;
                    menuTemp[menuItem.oriGldId].children.push(menuItem);
                }
            });
            this.treeData = renderData;
            this.$nextTick(() => {
                this.initChart(this.treeData);
            })
        },
        initChart(data){
            let self = this;
            let chartDom = document.getElementById("tableChart");
            this.myChart = this.$echarts.init(chartDom);
            // this.myChart.on('click', function(params) {
            //     var name = params.data.name;//点击的节点的name
            //     var value = params.data.value;//点击的节点的value
            //     //调用点击事件
            //     // clickNode(name,value);
            //     console.log(params)
            //     self.goldDetailDialogId = params.data.gldId;
            //     self.$refs.goldDetailDialog.open();
            // });
            let option = {
                tooltip: {
                    show:true,
                    trigger: 'item',
                    triggerOn: 'mousemove',
                    transitionDuration:0.2,
                    enterable:true,
                    position:function(point,params){
                        return point;
                    },
                    formatter:function(param){
                        if(param.data.isParent){
                            return param.data.name;
                        }
                        let e = param.data.gldId;
                        let isFin = self.goldTransferTypeFun(param.data);
                        return `<div style="">祺信编号：${param.data.gldId}</div><div style="">流转方：${param.data.pypt}</div><div style="">接收方：${param.data.name}</div><a onclick="clickChartTreeNode('${e}','${isFin}')" style="color:#4daaff;text-decoration: underline;">查看祺信详情</a>`;
                    }
                },
                series:[
                    {
                        type: 'tree',
                        id: 0,
                        name: 'tree1',
                        data: data,

                        top: '0%',
                        left: '0',
                        bottom: '30%',
                        right: '0',
                        scale:false,
                        move:false,
                        symbolSize: 25,
                        orient: 'vertical',
                        edgeShape: 'polyline',
                        edgeForkPosition: '40%',
                        initialTreeDepth: 999,

                        lineStyle: {
                            width: 1
                        },

                        label: {
                            // overflow:'truncate',
                            backgroundColor: '#FAFCFF',
                            position: 'bottom',
                            verticalAlign: 'middle',
                            align: 'center',

                            formatter:function(param){
                                if(param.data.isParent){
                                    return `{a|}\n\n\n{c|${param.data.name}}`;
                                }
                                return `{b|${self.goldTransferTypeFun(param.data)}}\n` + `{d|（${self.utils.splitK(param.data.gldAmt)}元 ${self.utils.dateFormat(new Date(param.data.transferTime),'yyyy-MM-dd')}）}\n` + self.getStatusHtml(param.data);
                            },
                            textStyle:{
                                lineHeight:20
                            },
                            rich:{
                                a:{
                                    padding:10,
                                },
                                b:{
                                    color: '#666',
                                    // position:'bottom',
                                },
                                c:{
                                    color: '#333',
                                    borderColor:'#91D5FF',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    lineHeight:30,
                                    backgroundColor:'#F1FBFF',

                                },
                                d:{
                                    color: '#999',
                                    fontSize:12,
                                    lineHeight:30,
                                },

                                blue:{
                                    color: '#333',
                                    borderColor:'#91D5FF',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    lineHeight:30,
                                    backgroundColor:'#F1FBFF',
                                },
                                red:{
                                    color: '#333',
                                    borderColor:'#FFA91D',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    backgroundColor:'#fff3e0',
                                },
                                grey:{
                                    color: '#333',
                                    borderColor:'#ccc',
                                    borderWidth:1,
                                    borderRadius:2,
                                    padding:[10,15],
                                    backgroundColor:'#FAFBFC',
                                }
                            }
                        },

                        leaves: {
                            label: {
                                // position: 'bottom',
                                // verticalAlign: 'middle',
                                // align: 'center'
                            }
                        },

                        emphasis: {
                            focus: 'descendant'
                        },

                        expandAndCollapse: true,
                        animationDuration: 550,
                        animationDurationUpdate: 750
                    }
                ]
            };
            option && this.myChart.setOption(option);
        },
        getStatusHtml(data){
            let className = 'blue';
            if(+data.gldStCd === 0 || +data.gldStCd === 5 || +data.gldStCd === 7){
                className = 'red';
            }
            else if(+data.gldStCd === 1 || +data.gldStCd === 6){
                className = 'blue';
            }
            else if(+data.gldStCd === 2 || +data.gldStCd === 3 || +data.gldStCd === 4 || +data.gldStCd === 8){
                className = 'grey';
            }
            if(data.isSelf){
                return ` {${className}|${data.name}（${this.utils.splitK(data.gldBal)} 元）}\n`;
            }else{
                return ` {${className}|${data.name}}\n`;
            }
        },
        getName(data){
            let name = "";
            name = this.goldTransferTypeFun(data);
            return name + "（ " + this.utils.splitK(data.gldAmt) + '<span style="margin-right:15px;">元</span>' + this.utils.dateFormat(new Date(data.transferTime),'yyyy-MM-dd') + " ）";
        },
        goldTransferTypeFun({goldTransferType}=data){
            switch (+goldTransferType) {
                case 0:
                    return '开立';
                case 1:
                    return '流转';
                case 2:
                    return '融资';
                case 3:
                    return '质押';
                case 4:
                    return '解质';
                default:
                    return null;
            }
        },
    },
    watch: {},
    activated() {}
}
</script>
<style scoped>
    .right-oper{
        float: right;
        margin: 0 10px 10px 0;
    }
    .chart-box{
        background: #FAFCFF;
        border:1px solid #E2ECF7;
        margin-top:15px;
        padding-bottom:15px;
    }

</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-flow-detail.vue